const sidebarFeatures = []

export const getSidebarFeatureByPath = (pathname) => {
  const feature = sidebarFeatures.find(
    (item) => pathname === item.path || pathname.startsWith(`${item.path}/`),
  )
  return feature?.component ?? null
}
